package com.dotdrives.repository

import com.dotdrives.client.SettingsClient
import com.dotdrives.model.BillingStatus
import com.dotdrives.model.Budget
import com.dotdrives.model.NewBudget
import com.dotdrives.model.NewTag
import com.dotdrives.model.OrgIntegrations
import com.dotdrives.model.Subscription
import com.dotdrives.model.Tag

interface SettingsRepository {
    suspend fun budgets(orgId: String): Result<List<Budget>>

    suspend fun addBudget(orgId: String, budget: NewBudget): Result<Budget>

    suspend fun updateBudget(orgId: String, id: String, budget: NewBudget): Result<Budget>
    suspend fun archiveBudget(orgId: String, id: String): Result<Unit>
    suspend fun updateTag(orgId: String, id: String, tag: NewTag): Result<Tag>
    suspend fun archiveTag(orgId: String, id: String): Result<Unit>

    suspend fun integrations(orgId: String): Result<OrgIntegrations?>

    /** Result.success(null) means RLS hid the row (field role) — not an error. See SettingsClient.subscription. */
    suspend fun subscription(orgId: String): Result<Subscription?>

    suspend fun billingStatus(orgId: String): Result<BillingStatus?>
    suspend fun setFiscalPeriod(orgId: String, month: Int, day: Int): Result<Unit> =
        Result.failure(UnsupportedOperationException("Fiscal period updates are unavailable"))

    suspend fun tags(orgId: String): Result<List<Tag>>

    suspend fun addTag(orgId: String, tag: NewTag): Result<Tag>
}

class SupabaseSettingsRepository(
    private val client: SettingsClient = SettingsClient(),
) : SettingsRepository {
    override suspend fun budgets(orgId: String): Result<List<Budget>> =
        runCatching { client.budgets(orgId) }

    override suspend fun addBudget(orgId: String, budget: NewBudget): Result<Budget> =
        runCatching { client.addBudget(orgId, budget) }

    override suspend fun updateBudget(orgId: String, id: String, budget: NewBudget) = runCatching { client.updateBudget(orgId, id, budget) }
    override suspend fun archiveBudget(orgId: String, id: String) = runCatching { client.archiveBudget(orgId, id) }
    override suspend fun updateTag(orgId: String, id: String, tag: NewTag) = runCatching { client.updateTag(orgId, id, tag) }
    override suspend fun archiveTag(orgId: String, id: String) = runCatching { client.archiveTag(orgId, id) }

    override suspend fun integrations(orgId: String): Result<OrgIntegrations?> =
        runCatching { client.integrations(orgId) }

    override suspend fun subscription(orgId: String): Result<Subscription?> =
        runCatching { client.subscription(orgId) }

    override suspend fun billingStatus(orgId: String): Result<BillingStatus?> =
        runCatching { client.billingStatus(orgId) }
    override suspend fun setFiscalPeriod(orgId: String, month: Int, day: Int): Result<Unit> =
        runCatching { client.setFiscalPeriod(orgId, month, day) }

    override suspend fun tags(orgId: String): Result<List<Tag>> =
        runCatching { client.tags(orgId) }

    override suspend fun addTag(orgId: String, tag: NewTag): Result<Tag> =
        runCatching { client.addTag(orgId, tag) }
}
